import * as React from 'react'
import { Component, PropsWithChildren } from 'react'
import { ErrorType, NormalizedError } from '../../reducers/errorReducer'
import { FrontendError } from './Errors'
import { SeverityLevel } from '@microsoft/applicationinsights-common'
import { appInsightsReact } from '../../pages/App'

type State = {
    error: NormalizedError
}

export default class ErrorBoundary extends Component<PropsWithChildren<void>, State> {
    state: State = {
        error: undefined,
    }

    static getDerivedStateFromError(error: Error) {
        return {
            error: {
                id: ErrorType.Frontend,
                type: ErrorType.Frontend,
                exception: error,
                message: error.message,
                trace: error.stack,
            },
        }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.log(`Catched error: {}.`, error.message)
        appInsightsReact.trackException({
            exception: error,
            severityLevel: SeverityLevel.Error,
            properties: { ...errorInfo, reactComponent: 'ErrorBoundary' },
        })
    }

    render() {
        if (this.state.error) {
            return <FrontendError error={this.state.error} dismiss={() => this.setState({ error: undefined })} />
        }
        return this.props.children
    }
}
